export default {
    methods: {
        /**
         * @param {Object} category
         * @returns {string}
         */
        resolveCategoryName(category) {
            return category.filterName || category.title
        },
    },
}
